module.exports = __webpack_public_path__ + "static/media/venueIcon.78b7dbea.svg";